var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.3759H14.9811C15.2532 14.6316 15.4896 13.878 15.69 13.1166H16.7986C18.2148 13.1166 19.367 11.9645 19.367 10.5483C19.367 9.13211 18.2148 7.97996 16.7986 7.97996H16.4885C16.511 7.54191 16.5227 7.10242 16.5227 6.66164V6.0757H3.43211V6.66164C3.43211 9.64801 3.9507 12.5769 4.97367 15.3759H0V16.5478H1.59871L2.67242 19.0761H17.2825L18.3562 16.5478H20V15.3759ZM16.7986 9.15188C17.5686 9.15188 18.1951 9.77832 18.1951 10.5484C18.1951 11.3184 17.5687 11.9448 16.7986 11.9448H15.9689C16.165 11.0233 16.309 10.0915 16.4011 9.15188H16.7986ZM15.3439 7.24762C15.3204 8.23059 15.2375 9.20648 15.0964 10.1724H4.85844C4.7173 9.20648 4.63445 8.23059 4.61098 7.24762H15.3439ZM5.05926 11.3443H14.8956C14.6258 12.7139 14.2368 14.0606 13.7298 15.376H6.22504C5.71809 14.0606 5.32906 12.7138 5.05926 11.3443ZM16.507 17.9042H3.44789L2.87187 16.5478H17.083L16.507 17.9042Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72504 4.80828H7.55316C7.55316 3.86465 7.99051 3.37262 8.34191 2.97727C8.63867 2.64344 8.83469 2.42289 8.83469 1.9248H10.0066C10.0066 2.86844 9.56922 3.36047 9.21781 3.75582C8.92105 4.08965 8.72504 4.3102 8.72504 4.80828Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3794 4.80828H10.2075C10.2075 3.86465 10.6448 3.37262 10.9963 2.97727C11.293 2.64344 11.489 2.42289 11.489 1.9248H12.6609C12.6609 2.86844 12.2236 3.36047 11.8721 3.75582C11.5754 4.08965 11.3794 4.3102 11.3794 4.80828Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.f9c2317cfc04dc46421b7ee9efff58f5.svg";
export { ForwardRef as ReactComponent };